// components/Spinner.tsx
import React from 'react';

const Spinner = () => (
    <div className="flex items-center justify-center fixed inset-0 z-50 bg-white bg-opacity-5">
        {/* <div className="w-12 h-12 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div> */}
        {/* <!-- Edge Y Ring Spinner s4 --> */}
        {/* <div className="w-12 h-12 rounded-full animate-spin border-y-4 border-solid border-green-500 border-t-transparent shadow-md"></div> */}
        <div className="w-8 h-8 rounded-full animate-spin border-y-4 border-solid border-green-500 border-t-transparent shadow-md"></div>

    </div>
);


export default Spinner;
